export default {
    Home: () => import('../pages/index.vue'),
    SSO: () => import('../pages/sso/index.vue'),
    Auth: () => import('../pages/auth/index.vue'),
    AuthResource: () => import('../pages/auth/resource/index.vue'),
    AuthRole: () => import('../pages/auth/role/index.vue'),
    AuthUser: () => import('../pages/auth/user/index.vue'),
    AuthConsole: () => import('../pages/auth/console/index.vue'),
    Search: () => import('../pages/search/index.vue'),
    Message: () => import('../pages/message/index.vue'),
    MessageOnsite: () => import('../pages/message/onsite/index.vue'),
    MessageReceiveManage: () => import('../pages/message/receive-manage/index.vue'),
    DataMap: () => import('../pages/data-map/index.vue'),
    DataMapMyTb: () => import('../pages/data-map/my-tb/index.vue'),
    DataMapMyTbOwn: () => import('../pages/data-map/my-tb/own/index.vue'),
    DataMapMyTbManage: () => import('../pages/data-map/my-tb/manage/index.vue'),
    DataMapMyTbAuth: () => import('../pages/data-map/my-tb/auth/index.vue'),
    DataMapDsManage: () => import('../pages/data-map/ds-manage/index.vue'),
    DataMapDsManageDetail: () => import('../pages/data-map/ds-manage/detail.vue'),
    DataMapTbManage: () => import('../pages/data-map/tb-manage/index.vue'),
    DataMapTbManageDetail: () => import('../pages/data-map/tb-manage/detail.vue'),
    DataMapDbManageDetail: () => import('../pages/data-map/db-manage/detail.vue'),
    DataVisual: () => import('../pages/data-visual/index.vue'),
    DataVisualDashboard: () => import('../pages/data-visual/dashboard/index.vue'),
    DataVisualDashboardContainer: () => import('../pages/data-visual/dashboard/container.vue'),
    DataVisualChartDemo: () => import('../pages/data-visual/chart-demo/index.vue'),
    DataVisualChartDemoIndexCard: () => import('../pages/data-visual/chart-demo/IndexCard.vue'),
    DataVisualChartDemoTable: () => import('../pages/data-visual/chart-demo/Table.vue'),
    DataVisualChartDemoLineBar: () => import('../pages/data-visual/chart-demo/LineBar.vue'),
    DataVisualChartDemoLineBarNotDate: () => import('../pages/data-visual/chart-demo/LineBarNotDate.vue'),
    DataVisualChartDemoLine: () => import('../pages/data-visual/chart-demo/Line.vue'),
    DataVisualChartDemoLineNotDate: () => import('../pages/data-visual/chart-demo/LineNotDate.vue'),
    DataVisualChartDemoBar: () => import('../pages/data-visual/chart-demo/Bar.vue'),
    DataVisualChartDemoBarStack: () => import('../pages/data-visual/chart-demo/BarStack.vue'),
    DataVisualChartDemoBarStackTop: () => import('../pages/data-visual/chart-demo/BarStackTop.vue'),
    DataVisualChartDemoBarTop: () => import('../pages/data-visual/chart-demo/BarTop.vue'),
    DataVisualChartDemoBarNotDate: () => import('../pages/data-visual/chart-demo/BarNotDate.vue'),
    DataVisualChartDemoArea: () => import('../pages/data-visual/chart-demo/Area.vue'),
    DataVisualChartDemoAreaNotDate: () => import('../pages/data-visual/chart-demo/AreaNotDate.vue'),
    DataVisualChartDemoPie: () => import('../pages/data-visual/chart-demo/Pie.vue'),
    DataVisualChartDemoPieRing: () => import('../pages/data-visual/chart-demo/PieRing.vue'),
    DataVisualChartDemoFunnel: () => import('../pages/data-visual/chart-demo/Funnel.vue'),
    DataVisualChartDemoFunnelDim: () => import('../pages/data-visual/chart-demo/FunnelDim.vue'),
    DataVisualChartDemoMap: () => import('../pages/data-visual/chart-demo/Map.vue'),
    DataVisualChartDemoChartFilter: () => import('../pages/data-visual/chart-demo/ChartFilter.vue'),
    DataVisualTemplate: () => import('../pages/data-visual/template/index.vue'),
    AboutMe: () => import('../pages/about-me/index.vue'),
    DataVisualChartDesign: () => import('../pages/data-visual/chart-design/index.vue'),
    DataApi: () => import('../pages/data-api/index.vue'),
    DataApiApp: () => import('../pages/data-api/app/index.vue'),
    DataApiAppDetail: () => import('../pages/data-api/app/detail.vue'),
    DataApiMarket: () => import('../pages/data-api/api-market/index.vue'),
    DataApiMy: () => import('../pages/data-api/my-api/index.vue'),
    DataApiGuideDev: () => import('../pages/data-api/my-api/GuideDev.vue'),
    DataApiMyDetail: () => import('../pages/data-api/my-api/detail.vue'),
    IndexSystem: () => import('../pages/index-system/index.vue'),
    IndexSystemIndex: () => import('../pages/index-system/index/index.vue'),
    IndexSystemDim: () => import('../pages/index-system/dim/index.vue'),
    IndexSystemBusiness: () => import('../pages/index-system/business/index.vue'),
    IndexSystemSubject: () => import('../pages/index-system/subject/index.vue'),
    DataSystem: () => import('../pages/data-system/index.vue'),
    DataSystemBusinessAnalyse: () => import('../pages/data-system/business-analyse/index.vue'),
    DataSystemBusinessAnalysePlate: () => import('../pages/data-system/business-analyse/plate/index.vue'),
    DataSystemBusinessAnalyseBusiness: () => import('../pages/data-system/business-analyse/business/index.vue'),
    DataSystemBusinessAnalyseProcess: () => import('../pages/data-system/business-analyse/process/index.vue'),
    DataSystemModelDesign: () => import('../pages/data-system/model-design/index.vue'),
    DataSystemModelDesignDim: () => import('../pages/data-system/model-design/dim/index.vue'),
    DataSystemModelDesignFact: () => import('../pages/data-system/model-design/fact/index.vue'),
    DataSystemModelDesignSubject: () => import('../pages/data-system/model-design/subject/index.vue'),
    DataSystemBasicConfig: () => import('../pages/data-system/basic-config/index.vue'),
    DataSystemBasicConfigDwLayer: () => import('../pages/data-system/basic-config/dw-layer/index.vue'),
    DataSystemBasicConfigWordMapping: () => import('../pages/data-system/basic-config/word-mapping/index.vue'),
}